<template>
  <container
    subHeaderTitle="세이프가드·금융사기방지<br /><b>보상 신청</b>"
    subHeaderText="가입자의 정보 확인이 꼭 필요합니다.<br />본인의 정보를 정확히 입력하시기 바랍니다."
    subHeaderAlign="center"
  >
    <section class="form-area mb-180">
      <v-container class="py-0">
        <v-row justify="center">
          <v-col cols="12" md="4" sm="6">
            <v-form v-model="valid" ref="form" onsubmit="return false;">
              <p>휴대폰번호</p>
              <div class="d-flex">
                <v-select
                  :items="items" 
                  item-text="text" 
                  item-value="value" 
                  v-model="teleCode"
                  solo
                />
                <v-text-field
                  v-model="cellTelNo"
                  :rules="rules.cellTelNoRules"
                  label="'-'를 제외하고 입력"
                  mask="###########"
                  solo
                />
              </div>
              <p>이름</p>
              <v-text-field v-model="name" :rules="rules.nameRules" label="이름" solo />
              <p>생년월일</p>
              <v-text-field v-model="birth" :rules="rules.birthRules" label="19990101" mask="########" solo />
              <p>성별</p>
              <v-btn-toggle color="primary" borderless mandatory v-model="genCd">
                <v-btn value="M">남</v-btn>
                <v-btn value="F">여</v-btn>
              </v-btn-toggle>
              <p class="mt-8 mb-2">이메일</p>
              <v-text-field v-model="email" :rules="rules.emailRules" label="help@finbridge.co.kr" solo />
              <div class="recaptcha-area top-sm">
                <vue-recaptcha ref="recaptcha" v-model="recaptchaVerify" @verify="onVerify" @expired="onExpired" :sitekey="$cfg.recaptchaSiteKey"></vue-recaptcha>
                <div class="v-messages theme--light error--text mt-2">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message" v-if="!recaptchaVerifyCheck">로봇이 아닙니다를 체크해주세요</div>
                  </div>
                </div>
              </div>
              <div>
                <v-btn class="submit" rounded block large depressed color="primary" v-on:click="submit"
                :data-ga-category="gaEvent.category.support.safeguard.compensation.name" :data-ga-label="gaEvent.category.support.safeguard.compensation.label1" :data-ga-action="gaEvent.actions.buttonClick"
                >보상신청</v-btn>
              </div>
              <div class="text-center mt-3">
                <v-btn class="back" text rounded @click.stop="goBack"
                :data-ga-category="gaEvent.category.support.safeguard.compensation.name" :data-ga-label="gaEvent.category.support.safeguard.compensation.label2" :data-ga-action="gaEvent.actions.buttonClick"
                >취소</v-btn>
              </div>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <!-- 처리 프로그레스 -->
    <v-dialog v-model="progressDialog" persistent max-width="100">
      <v-card>
        <v-progress-linear color="primary" indeterminate></v-progress-linear>
      </v-card>
    </v-dialog>
  </container>
</template>

<style lang="scss" scoped>
@import "@/styles/cscenter";
</style>

<script>
import Container from "@/pages/container/index.vue";
import PassSafeguardCompensation from "@/views/csCenter/PassSafeguardCompensation.vue";

export default {
  mixins: [PassSafeguardCompensation],
  name: "PassSafeguardCompensation",
  components: {
    Container
  },
  data() {
    return {
      items: [
        { text: 'SKT', value: '1' },
        { text: 'KT', value: '2' },
        { text: 'LG U+', value: '3' },
        { text: 'U+ 알뜰폰', value: '7' },
        { text: 'KT 알뜰폰', value: '8' }
      ],
      genCd: 'M',
    };
  },
  methods: {
    submit(e) {
      console.log(1)
      this.gaTracking(e);
      this.progressDialog = true;

      this.recaptchaVerifyCheck = this.recaptchaVerify;
      this.$refs.form.validate();
      //   console.log("this.valid", this.valid);
      if (!this.valid) {
        this.progressDialog = false;
        return false;
      }
      if (!this.recaptchaVerify) {
        this.progressDialog = false;
        return false;
      }
      
      if (this.teleCoCd == "1") {
        this.prdtNo = "A001";
      } else if (this.teleCoCd == "2") {
        this.prdtNo = "A003";
      } else if (this.teleCoCd == "3") {
        this.prdtNo = "A002";
      }

      // 보상신청
      this.axios
        .post("/rest/compensation", {
          type: this.type,
          teleCoCd: this.teleCoCd,
          cellTelNo: this.cellTelNo,
          birth: this.birth,
          genCd: this.genCd,
          name: this.name,
          prdtNo: this.prdtNo,
          email: this.email
        })
        .then((result) => {
          this.progressDialog = false;
          // console.log(result);
          // console.log(result.data.resultCd);
          if (result.data.resultCd === "S0000") {
            this.$router.push({
              name: "PassSafeGuardResult",
              params: { type: this.type, result: "SUCCESS" }
            });
          } else {
            // console.log("ERROR ", result.resultCd)
            this.$router.push({ name: "PassSafeGuardResult", params: { type: this.type, result: "FAIL" } });
          }
        })
        .catch((result) => {
          this.progressDialog = false;

          // console.log(result);
          // console.log("ERROR ", result.resultCd)
          this.$router.push({ name: "PassSafeGuardResult", params: { type: this.type, result: "FAIL" } });
        });
    },
    goBack(e) {
      this.gaTracking(e);
      this.$router.push({ name: 'Support' });
    }
  }
};
</script>
